export function authHeader() {
  // return authorization header with jwt token
  const accessToken = localStorage.getItem('auth');
  if (accessToken) {
    return { Authorization: `Bearer ${accessToken}` };
  } else {
    return {};
  }
}